import React from 'react';
import { openPreviousSidePanel, openSidePanel } from '@alfa-bank/newclick-core/window-utils';
import { OpenSidePanelsParams } from '@alfa-bank/newclick-types/open-side-panel-params';
import { NewClickVoipSidePanelWidget } from '@alfa-bank/newclick-voip-side-panel-widget';
import { Page } from '@alfa-bank/newclick-voip-side-panel-widget/types/constants';

import { useChat } from '#/src/shared/components/alternative-login/modals/components/modal-chat/hooks/use-chat';
import { useAppSelector } from '#/src/shared/hooks';
import { ApplicationState } from '#/src/shared/store/types';

import { useVoip } from './hooks/use-voip';
import { useVoipChanges } from './hooks/use-voip-changes';
import { phoneNumberDefault } from './constants';

interface Props {
    isMobile: boolean;
}

const VoipPanel: React.FC<Props> = ({ isMobile }) => {
    const env = useAppSelector((state: ApplicationState) => state.Settings.env);
    const isVoipEnabled = useAppSelector((state: ApplicationState) => state.App.isVoipEnabled);
    const isVoipCollapsedEnabled = useAppSelector(
        (state: ApplicationState) => state.App.isVoipCollapsedEnabled,
    );

    const { showVoip, handleBack, options } = useVoipChanges();
    const { closeVoip, openVoip } = useVoip();
    const { openChat } = useChat();

    const handleOpenChat = () => {
        closeVoip();
        openChat();
    };

    const platform = isMobile ? 'mobile' : 'desktop';

    const hasFeature = () => true;
    const trackInAnalytics = () => {};

    if (!isVoipEnabled && options?.view === 'voip') {
        return null;
    }

    if (!showVoip) {
        return null;
    }

    const handleClose = (calling?: boolean) => {
        if (calling === true) {
            openVoip({ view: Page.Voip });
        } else {
            closeVoip();

            if (sessionStorage.getItem('collapsedCall') !== 'true') {
                openSidePanel({ sidePanelId: 'Connections' } as unknown as OpenSidePanelsParams);
            }
        }
    };

    return (
        <NewClickVoipSidePanelWidget
            open={showVoip}
            onClose={handleClose}
            onBack={handleBack}
            goNext={openPreviousSidePanel}
            hasFeature={hasFeature}
            onOpenPreAuthChat={handleOpenChat}
            platform={platform}
            trackInAnalytics={trackInAnalytics}
            nodeEnv={env}
            isPreAuth={true}
            phoneNumber={options?.phoneNumber || phoneNumberDefault}
            collapsedDisable={!isVoipCollapsedEnabled}
            startView={options?.view}
            immediatelyStartCall={options?.immediatelyStartCall}
        />
    );
};

export default VoipPanel;
